import { combineReducers } from 'redux';
import stores from './stores';
import users from './users';
import settings from './settings';
import locations from './locations';
import cartLayouts from './cartLayouts';
import orderShipments from './orderShipments';
import totes from './totes';
import batches from './batches';
import loginCodes from './loginCodes';
import packingRules from './packingRules';
import products from './products';
import collections from './collections';
import tags from './tags';
import auditLogs from './auditLogs';

export default combineReducers({
  stores,
  locations,
  cartLayouts,
  orderShipments,
  totes,
  batches,
  users,
  loginCodes,
  packingRules,
  products,
  collections,
  tags,
  settings,
  auditLogs,
});
